module.exports = __webpack_public_path__ + "img/contact_text.9c4473d2.jpg";